import { createIconComponent } from '../../factory/create-icon-component';
export const ChevronLeftIcon = createIconComponent(
  'ChevronLeftIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.32503 8.77373L9.35456 6.7442C11.5175 4.58129 12.5989 3.49984 13.5274 3.42677C14.333 3.36336 15.1203 3.68947 15.6451 4.30397C16.25 5.01217 16.25 6.54157 16.25 9.60038V15.0805C16.25 16.9405 16.25 17.8705 16.0179 18.3737C15.4663 19.5697 14.0879 20.1406 12.8521 19.685C12.3322 19.4933 11.6746 18.8357 10.3594 17.5205L10.3594 17.5205L7.41413 14.5752L7.32503 14.4861L7.32502 14.4861C6.32526 13.4863 5.82539 12.9865 5.6381 12.41C5.47335 11.903 5.47335 11.3568 5.6381 10.8498C5.82539 10.2734 6.32527 9.77349 7.32503 8.77373Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
